import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { verifyEmail } from "../_redux/authCrud";
import { toAbsoluteUrl } from './../../../../_metronic/_helpers';
import SVG from "react-inlinesvg";


function VerifyEmail(props) {
    const { match: {
    params: { token },
  } } = props;
  const [isRequested, setIsRequested] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  
  useEffect(() => {
    setIsRequested(true);
    verifyEmail(token)
        .then((response) => {
          let { status, data } = response;

          if (status !== 200) {
              setIsRequested(false);
              setErrorMessage("Unable to verify your email. Please try again later.");
            return;
          }

          const { success, message } = data;

          if (!success) {
              setErrorMessage(message);
              setIsRequested(false);
              return;
          }

          setErrorMessage(null);
          setIsRequested(false);

        })
        .catch(() => {
          setIsRequested(false);
          setErrorMessage("Unable to verify your email. Please try again later.");
        });
  },[token]);


  return (
    <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
    {!isRequested && errorMessage && (
        <div className="text-center mb-10 mb-lg-20 d-flex flex-column align-items-center justify-content-center">
            <span className={`svg-icon svg-icon-xxl-10x svg-icon-danger`}>
              <SVG
                title="Verify Failed"
                src={toAbsoluteUrl("/media/svg/icons/Communication/Mail-error.svg")}
              />
            </span>
              <h3>{errorMessage}</h3>
          </div>
    )}
      {!isRequested  && !errorMessage && (
        <div className="login-form login-reset" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <span className={`svg-icon svg-icon-xxl-10x svg-icon-success`}>
              <SVG
                title="Verify Success"
                src={toAbsoluteUrl("/media/svg/icons/Communication/Readed-mail.svg")}
              />
            </span>
            <h3 className="font-size-h2 font-weight-normal mt-5"><FormattedMessage id="AUTH.VERIFY_EMAIL.REQUEST.SUCCESS.TITLE" /></h3>
            <h5 className="font-size-h5 font-weight-normal mt-5"><FormattedMessage id="AUTH.VERIFY_EMAIL.REQUEST.SUCCESS.MESSAGE_1" defaultMessage="We have successfully verified your email. " /><FormattedMessage id="AUTH.VERIFY_EMAIL.REQUEST.SUCCESS.MESSAGE_2" defaultMessage="You can now sign in to your account" /></h5>
          </div>
        </div>
      )}

      {isRequested && !errorMessage && (
          <div className="text-center mb-10 mb-lg-20 d-flex flex-row align-items-center justify-content-center">
             <span className="mr-12 spinner spinner-lg spinner-primary"></span>
              <h3><FormattedMessage id="AUTH.VERIFY_EMAIL.REQUEST.LABEL.VERIFYING" defaultMessage="Verifying email"/>....</h3>
          </div>
      )}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(VerifyEmail));
